import React from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import rings from "../assets/imges/collection-img/rings.webp"
import bracelets from "../assets/imges/collection-img/bracelets.webp"
import earings from "../assets/imges/collection-img/earings.webp"
import nacklace from "../assets/imges/collection-img/nacklace.webp"


// Helper function for image paths
const getImagePath = (filename) => `${ImageUrl}theme/showcase/${filename}`;

const collections = [
  { name: "Rings", path: "/jewelry/fashion-rings", image: rings },
  { name: "Bracelets", path: "/jewelry/bracelets", image: bracelets },
  { name: "Earrings", path: "/jewelry/earrings", image: earings },
  { name: "Necklaces", path: "/jewelry/necklaces", image: nacklace },
];

const ExploreCollection = () => {
  return (
    <section className="explore-collection section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Shop By Collection</h2>
          <p>Explore {Je_welryspelling} Collections by Style and Make a Statement.</p>
        </Heading>

        <Row>
          {collections.map(({ name, path, image }) => (
            <Col key={name} md={3} xs={6}>
              <div className="item text-center">
                <Link to={path} className="img-box" aria-label={`Shop ${name}`}>
                  <Image src={image} alt={name} loading="lazy" />
                </Link>
                <Link to={path}>{name}</Link>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ExploreCollection;
